module.exports = __webpack_public_path__ + "static/media/01.f72b9a1a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/mauritius/01.jpg
// module id = 493
// module chunks = 0